import { t } from '../../i18n';
import Cell from './Cell';

type TestResultScoreProps = {
  score: number | null;
};

const TestResultScore = ({ score, ...props }: TestResultScoreProps) => {
  let result = '-';

  if (typeof score === 'number') {
    if (score <= -1) result = t('Bloqueado') as string;
    else result = score.toString(10);
  }

  return (
    <Cell score={score ?? 0} {...props}>
      {result}
    </Cell>
  );
};

export default TestResultScore;
